import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-terms',
  templateUrl: './billing-terms.component.html',
  styleUrls: ['./billing-terms.component.css']
})
export class BillingTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
